var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeparture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746513903300,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 38977,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.16 332.507429l298.496 171.776-0.146286 1.499428v342.930286l-298.386285-171.702857V333.531429l0.036571-1.024z m643.145143-0.182858v205.897143l-5.888 0.182857c-120.795429 5.997714-203.702857 123.611429-168.374857 238.921143l-124.123429 71.387429v-343.771429l-0.036571-0.804571 298.422857-171.812572zM306.797714 220.16l2.413715 2.267429 2.852571 1.901714 291.035429 167.497143-125.586286 72.265143-297.325714-171.117715 126.537142-72.813714h0.073143z m170.861715-98.377143l297.325714 171.117714-125.513143 72.192L352.182857 193.974857l125.513143-72.228571z",
    "p-id": 38978,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M805.961143 584.448a139.044571 139.044571 0 0 1 139.337143 138.825143 139.044571 139.044571 0 0 1-139.337143 138.788571 139.044571 139.044571 0 0 1-139.227429-138.788571 139.044571 139.044571 0 0 1 139.227429-138.825143z m23.552 60.16l-32.804572 32.694857 22.820572 22.820572H713.142857v46.262857h106.569143l-23.04 23.04 32.841143 32.694857 78.774857-78.518857-0.256-0.256 0.256-0.219429-78.774857-78.518857z",
    "p-id": 38979,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparture);
export default __webpack_public_path__ + "static/media/departure.9194ba9fb5e7e5c890ee7c49e215cd4a.svg";
export { ForwardRef as ReactComponent };